<template>
      <span class="badge p-1 mr-1"
            :class="clazz">
      {{ stateStr }}
      </span>
</template>

<script>
import {invoiceState} from "../../utils/invoice-utils";

export default {
    name: "InvoiceStateBadge",
    props: {
        invoice: Object
    },
    computed: {
        clazz() {
            if (this.invoice.state === 'paid')
                return 'badge-success'
            if (this.invoice.state === 'pending')
                return 'badge-warning'
            if (this.invoice.state === 'canceled')
                return 'badge-danger'
            if (this.invoice.state === 'open')
                return 'badge-secondary'
              if (this.invoice.state === 'credited')
                    return 'badge-info'
              if (this.invoice.state === 'balanceing')
                    return 'badge-info'
            return 'badge-light'
        },
        stateStr() {
            return invoiceState(this.invoice.state)
        }
    }
}
</script>

<style scoped>

</style>
